import React from "react";
import { Map } from "@mui/icons-material";

import MapProvider from "fond/map/MapProvider";
import { BBox } from "fond/types/geometry";
import { Modal } from "fond/widgets";

import { ImageOverlayProvider } from "./ImageOverlayContext";
import ImageOverlayWizard from "./ImageOverlayWizard";

export interface ImageOverlayResult {
  imageName: string;
  imageUrl: string;
  imageCorners: [[number, number], [number, number], [number, number], [number, number]];
  opacity: number;
}

interface ImageOverlayModalProps {
  open: boolean;
  bbox?: BBox | null;
  onClose: () => void;
  onConfirm: (data: ImageOverlayResult) => void | Promise<void>;
}

const ImageOverlayModal: React.FC<ImageOverlayModalProps> = ({ open, bbox, onClose, onConfirm }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      fullscreen
      showClose
      variant="secondary"
      header="Add Image Overlay"
      headerSubtitle="Align the image with the map by specifying its corners"
      headerIcon={<Map />}
      DialogContentProps={{ style: { display: "flex", flex: 1, padding: 0, overflow: "hidden" } }}
      DialogActionsProps={{ style: { display: "none" } }}
      content={
        open ? (
          <ImageOverlayProvider>
            <MapProvider>
              <ImageOverlayWizard bbox={bbox} onClose={onClose} onConfirm={onConfirm} />
            </MapProvider>
          </ImageOverlayProvider>
        ) : undefined
      }
    />
  );
};

export default ImageOverlayModal;
